<template>
    <div class="regiment-detail" v-if="page_show">
        <!-- 商品详情 -->
        <div class="sale-box">
            <div class="flex sale__item">
                <img :src="group.product_cover_img" alt="">
                <div class="flex__null__around sale__item__right">
                    <span class="fs_26 c_1a lh_36 ellipsis_two">{{group.product_name}}</span>
                    <div>
                        <span class="fs_30 c_main"><span class="fs_22">¥</span>{{group.product_price_group}}</span>
                        <span class="fs_24 c_98 line_through"><span class="fs_22">¥</span>{{group.product_price_original}}</span>
                    </div>
                </div>
                <div class="flex align-center sale__item__tips" v-if="group.status==2||group.status==3">
                    <span class="fs_30 c_ff">{{convert[group.status]}}</span>
                </div>
                <div class="flex align-center sale__item__tips sale__item__tips--no" v-else>
                    <span class="fs_30 c_b3">{{convert[group.status]}}</span>
                </div>
            </div>
        </div>
        <!-- 团信息 -->
        <div class="flex__center__null wrap content">
            <div class="flex wrap content__header">
                <div v-for="(item,index) in order" :key="index">
                    <img v-if="item.id>0" :src="item.headimgurl" alt="">
                    <img v-if="item.id==0" src="@/assets/images/question.png" alt="">
                    <img v-if="item.id==-1" src="@/assets/images/ellipsis.png" alt="">
                </div>
            </div>
            <div class="flex align-center content__content" v-if="group.rest_number">
                <span class="fs_32 c_1a">仅剩</span>
                <span class="fs_32 c_main">&nbsp;{{group.rest_number}}人&ensp;</span>
                <div class="timing-tips">
                    <span class="fs_28 c_ff">{{hour}}</span>
                </div>
                <span class="fs_28 c_1a">&ensp;时&ensp;</span>
                <div class="timing-tips">
                    <span class="fs_28 c_ff">{{minute}}</span>
                </div>
                <span class="fs_28 c_1a">&ensp;分&ensp;</span>
                <div class="timing-tips">
                    <span class="fs_28 c_ff">{{second}}</span>
                </div>
                <span class="fs_28 c_1a">&ensp;秒&ensp;</span>
            </div>

            <div class="content__footer">
                <button v-if="group.status==2&&is_exit==1" @click="share_show=!share_show">邀请好友参团</button>
                <button v-if="group.status==2&&is_exit==0" @click="sku_show=true">一键参团</button>
                <button v-if="group.status==3||group.status==4" v-link="'/Assemble/Index'">去首页</button>
            </div>
        </div>
        <!-- 详情 -->
        <div class="modular">
            <div class="modular__title">
                <span class="fs_36 c_1a">拼团须知</span>
            </div>
            <div v-html="collage_notes">{{collage_notes}}</div>
        </div>
        <!-- 分享浮层 -->
        <share-layer :show_share="share_show" @isShow="isShow"></share-layer>
        <!-- 规格 -->
        <sku v-if="sku_show" :sku_show="sku_show" :group_id="group_id" :product_id="group.product_id" @isSku="isSku"></sku>
    </div>
</template>
<script>
export default {
    name:"RegimentDetail",
    data(){
        return{
            page_show:false,// 页面展示优化
            sku_show: false, //规格modal
            share_show: false, //分享图层
            hour: '00',
            minute: '00',
            second: '00',
            group_id: 0,
            group:{},
            order:[],
            is_exit:0,
            collage_notes: '',
            convert:{2:'等待成团',3:'拼团成功',4:'拼团失败'}
        }
    },
    methods:{
        // 分享图层
        isShow(data){
            this.share_show=data;
        },
        // 规格子组件传值
        isSku(data){
            this.sku_show=data;
        }
    },
    mounted(){
        this.group_id=this.$route.params.id;
        this.axios.post('/wechat.php/Collage/getGroupStatus', {
            user_id: localStorage.user_id,
            group_id: this.$route.params.id
        }).then(
            res=>{
                if(res.data.code==1){
                    this.page_show=true;
                    this.group=res.data.data.group; //商品信息
                    this.order=res.data.data.order; //中奖人
                    this.is_exit=res.data.data.is_exit; //是否参团
                    this.collage_notes=res.data.data.collage_notes.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
                    // 倒计时
                    if(this.group.status==2){
                        let current_time = Date.parse(new Date()) / 1000;
                        var totalSecond = this.group.end_time - current_time;
                        this.interval = setInterval(function () {
                            // 秒数
                            var second = totalSecond;
                            // 小时位
                            var hr = Math.floor((second) / 3600);
                            var hrStr = hr.toString();
                            if (hrStr.length == 1) hrStr = '0' + hrStr;

                            // 分钟位
                            var min = Math.floor((second - hr * 3600) / 60);
                            var minStr = min.toString();
                            if (minStr.length == 1) minStr = '0' + minStr;

                            // 秒位
                            var sec = second - hr * 3600 - min * 60;
                            var secStr = sec.toString();
                            if (secStr.length == 1) secStr = '0' + secStr;
                                this.hour=hrStr,
                                this.minute=minStr,
                                this.second=secStr,
                                totalSecond--;
                            if (totalSecond < 0) {
                                clearInterval(this.interval);
                                this.$toast('活动已结束');
                                this.hour='00';
                                this.minut='00';
                                this.second='00';
                            }
                        }.bind(this), 1000);
                    }

                    // 分享预配置
                    this.$wx.setConfig();
                    this.$wx.share({
                        title: this.group.product_name, 
                        link:"https://ym.jucheng01.net/vue/Assemble/RegimentDetail/" + this.$route.params.id,
                        imgUrl: this.group.product_cover_img 
                    })
                }
            }
        )

    }
}
</script>
<style scoped>
.sale__item{
    position: relative;
    padding: 30px;
    background: #fff;
    overflow: hidden;
}
.sale__item__tips{
    position: absolute;
    bottom: 30px;
    right: 0;
    height: 60px;
    padding: 0 20px;
    border-radius: 30px 0 0 30px;
    background: #F93A42;
}
.sale__item__tips--no{
    background: #e6e6e6;
}
.sale__item img{
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.sale__item__right{
    width: 480px;
    margin-left: 30px;
}
.modular{
    margin-top: 15px;
    padding: 0 30px 30px;
    background: #fff;
}
.modular__title{
    padding: 30px 0;
}
.content{
    padding: 30px;
    margin-top: 15px;
    background: #fff;
}
.content__header{
    width: 690px;
    padding: 0 80px;
}
.content__header img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.content__header>div{
    margin: 20px 0 0 30px;
}
.content__header>div:first-child{
    margin-left: 0;
}
.content__header>div:nth-child(6){
    margin-left: 55px;
}
.content__content{
    margin-top:60px;
}
.content__footer{
    margin-top:30px;
}
.content__footer button{
    width: 690px;
    height: 90px;
    font-size: 32px;
    color: #fff;
    background: #F93A42;
    border-radius: 10px;
}
/* 倒计时 */
.timing-box{
    height: 80px;
    padding: 0 15px;
    margin-top: 20px;
    background: #FAF2ED;
}
.timing-tips{
    min-width: 48px;
    height: 48px;
    padding: 0 8px;
    background: #1a1a1a;
    border-radius:6px;
    text-align: center;
    line-height: 48px;
}

/* 规格model */
.model{
  position: fixed;
  bottom: 0;
  z-index: 3;
  width: 100%;
  background: #fff;
}
.model__info{
  display: flex;
  padding: 30px 30px 0;
}
.model__info img{
  display: block;
  width: 220px;
  height: 220px;
  margin-top: -60px;
  border: 2px solid #E6E6E6;
  border-radius: 10px;
  background: #fff;
}
.model__info__right{
  width: 440px;
  margin-left: 30px;
}
.size-table{
  width: 120px;
  height: 30px;
  background: #1a1a1a;
  line-height: 30px;
}
.model__spec-box{
    max-height: 700px;
    padding: 0 30px;
    margin: 10px 0;
    overflow: auto;
}
.model__spec{
  padding: 30px 0;
  border-bottom: 2px solid #e6e6e6;
}
.model__spec__item{
    min-width: 60px;
    margin: 20px 20px 0 0;
    padding: 0 20px;
    height: 60px;
    line-height: 56px;
    text-align: center;
    font-size: 26px;
    color: #989898;
    border: 2px solid #CBCBCB;
    border-radius: 6px;
}
.active{
    color: #F93A42;
    border: 2px solid #F93A42;
}
.actives{
    background: #e8e8e8;
    color: #c8c9cc;
    border: none;
}
.model__num{
    height: 120px;
}
/* 计步器 */
.stepper_components{
    display: flex;
    justify-content: space-between;
    width: 200px;
    border: 2px solid #e6e6e6;
}
.stepper_components .count{
    width: 66px;
    height: 60px;
    line-height: 60px;
    text-align: center;
}
.stepper_components .count--big{
    width: 85px;
    height: 60px;  
    border-right: 2px solid #e6e6e6;
    border-left: 2px solid #e6e6e6;
    text-align: center;
}

.model__footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/pages/assemble/RegimentDetail.vue